import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { MakeProvider } from '../../../../helpers/base-control-value-accessor';
import { FormValue } from '../../../entities/form-value.entity';
import { ShFormCheckboxComplexBaseComponent } from '../base-complex/form-checkbox-complex-base.component';
import { NgIf, AsyncPipe } from '@angular/common';
import { ShIndeterminateDirective } from '../../../directives/indeterminate.directive';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'sh-form-checkbox-base',
    templateUrl: '../base-complex/form-checkbox-complex-base.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(ShFormCheckboxBaseComponent)],
    standalone: true,
    imports: [ReactiveFormsModule, ShIndeterminateDirective, NgIf, AsyncPipe]
})
export class ShFormCheckboxBaseComponent extends ShFormCheckboxComplexBaseComponent {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    propagateChange(fv: FormValue<boolean | null>): void {
        this.propagateSimpleChange(FormValue.unwrap(fv));
    }

    writeValue(obj: any): void {
        super.writeValue(FormValue.wrap(obj));
    }
}
